export const refundNotice = (policy: string) => {
  if (policy === 'strict_partial') return '2 weeks'
  if (policy === 'strict_30') return '30 days'
  if (policy === 'strict_60') return '60 days'
  return '1 week'
}

export const refundAmount = (policy: string) => {
  const fullPolicies = ['full', 'strict_30', 'strict_60']
  if (fullPolicies.includes(policy)) return 'full'
  return '50%'
}
